<template>
  <button class="group flex w-full max-w-[146px] select-none flex-col items-center" @click="selectedBrand">
    <div
      class="flex h-[146px] w-full items-center justify-center border p-2.5 transition duration-300 ease-out group-hover:shadow-brandItem"
      :class="{
        'border-ng800 bg-ng40': props.selected,
        'border-transparent': !props.selected,
      }"
    >
      <img
        class="h-auto w-full max-w-[146px] select-none object-contain"
        :src="props?.brand?.attributes?.logo?.data?.attributes?.url"
        :alt="props?.brand?.attributes?.logo?.data?.attributes?.alternativeText || ''"
        width="146"
        draggable="false"
        height="146"
      />
    </div>
    <div class="subtitle mt-1 text-center">
      {{ props.brand?.attributes?.subtitle }}
    </div>
  </button>
</template>
<script setup lang="ts">
import { BrandWithProductsFragment } from "#gql";

const props = defineProps<{
  brand: BrandWithProductsFragment | null | undefined;
  selected: boolean;
}>();

const emit = defineEmits<{
  (e: "selected", brand: BrandWithProductsFragment | null | undefined): void;
}>();

function selectedBrand() {
  if (props.selected) {
    emit("selected", null);
    return;
  }

  emit("selected", props.brand);
}
</script>
<style lang="scss" scoped></style>
